import Vue from "vue";
import router from "@/router";

import { URL_API } from "../../settings/apiConnect";

export default {
  state: {
    token: "",
    currentUser: {},
    userRole: null
  },
  mutations: {
    async initToken(state) {
      if (localStorage.getItem("token") != null) {
        state.token = localStorage.getItem("token");
        //Убрать в проде токен!!!
        console.log(state.token);
        Vue.axios.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${state.token}`;
        state.userRole = parseInt(localStorage.getItem("userRole"));
      }
    },

    async clearToken(state) {
      localStorage.removeItem("token");
      localStorage.removeItem("userRole");
      state.token = "";
      Vue.axios.defaults.headers.common["Authorization"] = null;
      await router.push("/login");
    },

    updateToken(state, token) {
      localStorage.setItem("token", token);
      state.token = token;
      Vue.axios.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${state.token}`;
    },

    updateCurrentUser(state, data) {
      localStorage.setItem("userRole", data.roles[0].id);
      state.userRole = data.roles[0].id;
      state.currentUser = data;
    }
  },
  actions: {
    handleNoAuth(context) {
      Vue.axios.interceptors.response.use(undefined, error => {
        if (error.response) {
          if (error.response.status === 401) {
            console.log(context);
            if (router.currentRoute.name !== "Login")
              context.dispatch("logoutUser");
          }
        }
      });
    },
    async loginUser(context, { email, password }) {
      const config = {};
      const body = {
        email: email,
        password: password
      };
      try {
        const response = await Vue.axios.post(`${URL_API}login`, body, config);
        const data = response.data;
        if (data.access_token) {
          context.commit("updateToken", data.access_token);
          context.commit("updateMessage", "Успешно", {
            root: true
          });
          window.OneSignal.push(async function() {
            await context.dispatch(
              "storePlayerId",
              await window.OneSignal.getUserId()
            );
          });
          await router.push("/main/map");
        }
      } catch (error) {
        context.commit("updateMessage", "Введен неверный e-mail или пароль", {
          root: true
        });
      }
    },

    async getCurrentUser(context) {
      const config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      const response = await Vue.axios.get(
        `${URL_API}user/getCurrentUser`,
        config
      );
      context.commit("updateCurrentUser", response.data);
    },

    async storePlayerId(context, playerId) {
      const config = {};
      const body = {
        player_id: playerId
      };
      await Vue.axios.post(`${URL_API}player-id/store`, body, config);
    },

    async logoutUser(context) {
      var playerId;
      try {
        window.OneSignal.push(async function() {
          try {
            playerId = await window.OneSignal.getUserId();
            await Vue.axios.delete(
              `${URL_API}player-id/destroy?player_id=${playerId}`
            );
          } finally {
            await context.commit("clearToken");
          }
        });
      } finally {
        await context.commit("clearToken");
      }
    }
  }
};
